'use client';

import { c as _c } from "react/compiler-runtime";
import type { Address, ChainId } from '@morpho-org/blue-sdk';
import { DataList } from '@morpho-org/ui-v6/client';
import { getRiskDisclosure } from '@/config/risk-disclosures';
import { RiskDisclosureText } from './components';
export interface RiskDisclosureClientProps {
  address: Address;
  chainId: ChainId;
}
function RiskDisclosureClient(t0) {
  const $ = _c(5);
  const {
    address,
    chainId
  } = t0;
  let t1;
  if ($[0] !== address || $[1] !== chainId) {
    t1 = getRiskDisclosure(chainId, address);
    $[0] = address;
    $[1] = chainId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const riskDisclosure = t1;
  const t2 = riskDisclosure?.disclosure ?? "Curator has not submitted a Disclosure.";
  let t3;
  if ($[3] !== t2) {
    t3 = <DataList.Root fullWidth={true}><DataList.Column><RiskDisclosureText content={t2} /></DataList.Column></DataList.Root>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export default RiskDisclosureClient;